// CB:BEGIN fr-001-settings-page-redirect
import React, { useEffect } from 'react';
import { useUser, useClerk } from '@clerk/clerk-react';
import SharedHeaderCustomer from '../../components/SharedHeaderCustomer';

const Settings: React.FC = () => {
  const { user } = useUser();
  const { openUserProfile } = useClerk();

  useEffect(() => {
    // Auto-open Clerk modal when Settings page loads
    if (user) {
      openUserProfile();
    }
  }, [user, openUserProfile]);

  return (
    <div className="container">
      <SharedHeaderCustomer onNavigate={() => {}} />
      <div className="content" style={{ padding: '40px 20px', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
        <h1 style={{ 
          fontSize: '36px', 
          fontWeight: '700', 
          color: '#1f2937',
          marginBottom: '16px'
        }}>
          Account Settings
        </h1>
        <p style={{ 
          fontSize: '18px', 
          color: '#6b7280',
          marginBottom: '32px'
        }}>
          Account settings are managed in your profile modal.
        </p>
        <button
          onClick={() => openUserProfile()}
          style={{
            padding: '12px 24px',
            background: '#2563eb',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500',
          }}
        >
          Open Account Settings
        </button>
      </div>
    </div>
  );
};
// CB:END fr-001-settings-page-redirect

export default Settings;